// extracted by mini-css-extract-plugin
module.exports = {"header":"LayoutHeader_header__2P-dp","nav":"LayoutHeader_nav__2qWqs","dropdownBtnImg":"LayoutHeader_dropdownBtnImg__18ykS"};